// Lib
import React from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { refreshPageAndClearLocalCache } from '../../../reducers/navigationActions';
import { intercomShowMessages } from '../../../analytics/analyticsActions';

// Components
import ModalActionsList from '../../modal/ModalActionsList';
import LinkButton from '../../buttons/LinkButton';

const AppInitialisationErrorContent: React.FC = () => {
    const dispatch = useDispatch();

    const dispatchRefreshPage = (event: Event) => {
        event.preventDefault();
        dispatch(refreshPageAndClearLocalCache());
    };

    const actions = [{ text: 'Try again', func: dispatchRefreshPage }];

    return (
        <>
            <h2>Something went wrong</h2>
            <div>
                <p>The application failed to load.</p>
                <ModalActionsList actions={actions} />
            </div>
            <div className="section">
                <p>
                    Need help? <LinkButton onClick={() => dispatch(intercomShowMessages())}>Contact support</LinkButton>
                </p>
            </div>
        </>
    );
};

export default AppInitialisationErrorContent;
